var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "status-up_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M7.37988 18.1501V16.0801",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M12.5 18.1498V14.0098",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.4,
    d: "M17.6201 18.1497V11.9297",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6199 5.84961L17.1599 6.38961C14.6099 9.36961 11.1899 11.4796 7.37988 12.4296",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.6904 5.84961H17.6204V8.76961",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.5 22H15.5C20.5 22 22.5 20 22.5 15V9C22.5 4 20.5 2 15.5 2H9.5C4.5 2 2.5 4 2.5 9V15C2.5 20 4.5 22 9.5 22Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/Status.478c583f54b92dfe1c3711bd68520996.svg";
export { ForwardRef as ReactComponent };